import pickBy from "lodash/pickBy";

export const resetRowChildrenPagination = (paginationByRowKey: Record<string, unknown>, rowKey: string) =>
  pickBy(paginationByRowKey, (value, key) => !key.includes(rowKey));
